import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_SECURITY_DEPOSIT, propTypes } from '../../util/types';
import { getDepositStatus } from '../../util/securityDeposit';

import css from './OrderBreakdown.module.css';

const STATUS_MESSAGE_ID = {
  refunded: 'OrderBreakdown.securityDepositRefunded',
  retained: 'OrderBreakdown.securityDepositRetained',
  'partially-refunded': 'OrderBreakdown.securityDepositPartiallyRefunded',
};

/**
 * Renders the refundable security deposit line item in the order breakdown.
 *
 * The deposit is charged to the customer only (not paid out to the provider).
 * Status badges (refunded / retained / partial) are derived from transaction transitions.
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems - The line items to render
 * @param {propTypes.transaction} [props.transaction] - The transaction (used for deposit status)
 * @param {intlShape} props.intl - The intl object
 * @returns {JSX.Element|null}
 */
const LineItemSecurityDepositMaybe = props => {
  const { lineItems, transaction, intl } = props;

  const depositLineItem = lineItems.find(
    item => item.code === LINE_ITEM_SECURITY_DEPOSIT && !item.reversal
  );

  if (!depositLineItem) {
    return null;
  }

  const status = getDepositStatus(transaction);
  const statusMessageId = STATUS_MESSAGE_ID[status];

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.securityDeposit" />
        {statusMessageId ? (
          <span className={css.depositStatus}>
            {' '}
            <FormattedMessage id={statusMessageId} />
          </span>
        ) : null}
      </span>
      <span className={css.itemValue}>{formatMoney(intl, depositLineItem.lineTotal)}</span>
    </div>
  );
};

export default LineItemSecurityDepositMaybe;
